import { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "store/reducers";
import { AppDispatch } from "store/store";
import { addNotification } from "store/notification/slice";
import { NotificationType } from "store/notification/types";

export const useReferralLink = () => {
    const { userInfo } = useSelector((state: RootState) => state.user);
    const dispatch = useDispatch<AppDispatch>();

    const [shareLink, setShareLink] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);
    const [clipboardExists] = useState(!!navigator.clipboard);

    useEffect(() => {
        const getShareLink = async () => {
            try {
                const shareResponse = await fetch(
                    `https://api.partnerstack.com/v1/partnerships/anonymous/switcherinc/${userInfo?.User?.Details?.Email}`,
                    {
                        method: "POST"
                    }
                );

                if (shareResponse.ok) {
                    const responseJson = await shareResponse.json();
                    const responseRData = JSON.parse(responseJson.rdata);
                    setShareLink(responseRData.link);
                } else {
                    setShareLink(null);
                }
            } catch (error) {
                setShareLink(null);
            } finally {
                setLoading(false);
            }
        };

        if (userInfo?.User?.Details?.Email) {
            getShareLink();
        } else {
            setLoading(false);
        }
    }, [userInfo]);

    const copyLink = useCallback(async () => {
        if (clipboardExists && shareLink) {
            await navigator.clipboard.writeText(shareLink);

            dispatch(
                addNotification({
                    type: NotificationType.Info,
                    message: "messages:copy-referral-link"
                })
            );
        }
    }, [dispatch, shareLink, clipboardExists]);

    return { shareLink, loading, copyLink };
};
